import React, { Component } from 'react';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';
import Modal from '../../../components/Modal';
import { htmlTemplates, printLabel, traceabilityReprint } from '../../../libs/services';

class PrintLabel extends Component{
    constructor(props){
        super(props);

        this.openModal = this.openModal.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onClear = this.onClear.bind(this);
        this.printing = this.printing.bind(this);
        this.onCheckPlantilla = this.onCheckPlantilla.bind(this);

        this.state = {
            options:[],
            id:'',
            file_type:'',
            extraction_name:'',
            option:'',
            traceability:false,
            reference_id:'',
            label_type:'',
            hf_id:'',
            extraction_type:'',
            options:[]
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    async openModal(label_type, id, extraction, direct, option, traceability, reference_id = null){
        var hf_id = sessionStorage.getItem('health_facilities_id');
        var extraction_type = '';
        if(extraction == 'ST'){
            extraction_type = 'SANGRE TOTAL';
        }else if(extraction === 'AF'){
            extraction_type = 'AFÉRESIS'
        }else if(extraction === 'CEL'){
            extraction_type = 'CÉLULAS'
        }else{
            extraction_type = extraction;
        }

        this.setState({
            option: option, 
            traceability: traceability,
            reference_id: reference_id
        });
        
        var response = await htmlTemplates(hf_id, label_type, extraction);
        if(response){
            if(response.res === 0){
                swal('Error', 'No existen formatos definidos para este tipo de impresión.', 'error');
            }else{
                await this.setState({
                    id: id,
                    file_type: label_type,
                    extraction_name: extraction_type,                    
                });

                if(response.res === 1){
                    await this.printing([]);
                }else{
                    if(direct){
                        await this.printing([]);
                    }else{
                        var opt = []
    
                        for(var i = 0; i <= parseInt(response.res,10); i++){	
                            if(i === 0){
                                opt.push({value:i, check:false});
                            }else{
                                opt.push({value:i-1, check:false});
                            }			
                        }
    
                        this.setState({
                            options: opt,
                        });
    
                        this.modal.handleShow();
                    }
                }

                
            }
        }
    }

    onPrint(){
        let etiquetas = [];
        
        this.state.options.map((option, i)=>{
            if(option.check){
                if(i === 0){
                    etiquetas = [];
                }else{
                    etiquetas.push(option.value);
                }
            }
        });

        this.printing(etiquetas);
    }

    onClear(){
        this.setState({
            options:[],
            id:'',
            file_type:'',
            extraction_name:'',
            option:'',
            traceability:false,
        });
    }

    async printing(etiquetas){
        var hf_id = sessionStorage.getItem('health_facilities_id');
        var obj = {
            health_facilities_id: hf_id,
            id: this.state.id,
            file_type: this.state.file_type,
            nEtiqueta: etiquetas,
            name: this.state.extraction_name
        }
        var response;

        await this.props.waiting.handleShow('Imprimiendo...');
        if(this.state.option === 'multiple'){

        }else{
            response = await printLabel(obj);
        }

        if(response){
            if(this.props.preview_print.value === 'NO'){
                await this.props.openFileNewWindow(response);
            }else{
                await this.props.directPrint(response, this.state.file_type);
            }

            if(this.state.traceability){
                await this.traceability();
            }

            await this.modal.handleClose();
        }
        await this.props.waiting.handleClose();
    }

    async traceability(){
        var obj = {
            action: this.state.file_type === 'label_register_cells' ? 'CELLS' : 
                    this.state.file_type === 'label_register' ? 'OFFERS' : 'DONATIONS',
            description: this.state.option === 'reprint' ? 'REPRINT' : 'PRINT',
            offers_id: this.state.id
        };

        await traceabilityReprint(obj);
        
    }

    onCheckPlantilla(i){
        let options = this.state.options.map((option, index)=>{
            if(i === index){
                option.check = !option.check;
            }

            return option;
        });

        this.setState({options});
    }

    render(){
        const {t} = this.props;

        return(
            <Modal
                {...this.props}
                title={t('content.modal_print_label.MAIN')}
                actionBtn={true}
                label="Imprimir"
                action={this.onPrint} 
                size="sm"
                clear={this.onClear}
                onRef={ref => this.modal = ref}
            >
                <div className='row'>
                    <div className='col-xs-12'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Plantilla</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.options.map((option, i)=>
                                    <tr key={i}>										
                                        <td>
                                            <input type="checkbox" value={option.value} name={'o'+i} id={'o'+i} 
                                                onChange={()=>this.onCheckPlantilla(i)} checked={option.check}/>
                                        </td>
                                        <td>{i === 0 ? 'Todos' : i}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default PrintLabel;